import { render } from "./PdfGenerationTest.vue?vue&type=template&id=6fa02251"
import script from "./PdfGenerationTest.vue?vue&type=script&lang=js"
export * from "./PdfGenerationTest.vue?vue&type=script&lang=js"

import "./PdfGenerationTest.vue?vue&type=style&index=0&id=6fa02251&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__